/**
 * Module-level active org ID, readable by the API client without React context.
 *
 * OrgProvider calls setActiveOrgId whenever the active org changes;
 * apiClient reads getActiveOrgId to set the X-Org-Id header.
 */

let activeOrgId = null;

export function getActiveOrgId() {
  return activeOrgId;
}

export function setActiveOrgId(orgId) {
  activeOrgId = orgId || null;
}
